// extracted by mini-css-extract-plugin
export default {"filterGraphs":"ExpenseFilterGraphs_filterGraphs__U4xjU"};